

export const Footer = () => {
  return (
    <>
       <footer className="mb-0">
        <p>Powered by Sophie Ferdz &hearts;</p>
       </footer>
    </>
  )
}
